import React from 'react';

import useFavoriteListing from '../hooks/useFavoriteListing';

interface Children {
  onClick: React.MouseEventHandler;
  isLoading: boolean;
  isFavorite: boolean;
}

interface Props {
  listingId: number;
  children: (p: Children) => JSX.Element;
}

export const FavoriteListingContainer: React.FC<Props> = ({
  children,
  listingId,
}) => {
  const { isFavorite, isLoading, onClick } = useFavoriteListing(listingId);

  return children({
    onClick,
    isFavorite,
    isLoading,
  });
};

export default FavoriteListingContainer;
